var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationsZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1699 6.67475C16.1699 3.61096 13.6468 1.08789 10.583 1.08789C7.51921 1.08789 4.99609 3.61096 4.99609 6.67475C4.99609 10.8199 10.583 16.4068 10.583 16.4068C10.583 16.4068 16.1699 10.8199 16.1699 6.67475Z",
    stroke: "#414042",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5823 8.74739C11.727 8.74739 12.6549 7.81943 12.6549 6.67479C12.6549 5.53015 11.727 4.60229 10.5823 4.60229C9.43769 4.60229 8.50977 5.53015 8.50977 6.67479C8.50977 7.81943 9.43769 8.74739 10.5823 8.74739Z",
    stroke: "#58A291",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9256 13.7034H17.1609C17.5213 13.7034 17.8818 13.9737 17.9719 14.3341L19.9543 19.7408C20.1345 20.3716 19.7741 20.9123 19.1433 20.9123H1.93205C1.30127 20.9123 0.850716 20.2815 1.12105 19.7408L3.1035 14.3341C3.19361 13.9737 3.55406 13.7034 3.9145 13.7034H8.14974",
    stroke: "#414042",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsZip);
export default __webpack_public_path__ + "static/media/LocationsZip.480e58a1bd6df873cf00882e460b129d.svg";
export { ForwardRef as ReactComponent };